module.exports = {
  sidebarWidth: 400,
  sidebarHeight: 42,
  isSmallScreen() {
    return window.innerWidth <= 800;
  }
}


// WEBPACK FOOTER //
// ./src/config.js